"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { cx } from "@/lib/tailwind-utils";
import { useNavigationSearchOpenStore } from "@/stores/navigation-search-store";

/** Detect tablets only (iPad + Android tablets), excluding phones */
function useIsTablet() {
  const $ = _c(2);
  const [isTablet, setIsTablet] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const isIPad = /iPad/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
      const isAndroidTablet = /Android/.test(navigator.userAgent) && !/Mobile/.test(navigator.userAgent);
      setIsTablet(isIPad || isAndroidTablet);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isTablet;
}
export function SearchEdgeTab() {
  const $ = _c(6);
  const isTablet = useIsTablet();
  const {
    isOpen,
    openSearch
  } = useNavigationSearchOpenStore();
  if (!isTablet || isOpen) {
    return null;
  }
  let t0;
  if ($[0] !== openSearch) {
    t0 = () => openSearch("floating_button");
    $[0] = openSearch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cx("fixed bottom-20 right-0 z-[45]", "flex h-12 w-6 items-center justify-center", "rounded-l-lg border border-r-0 border-border", "bg-background/90 text-foreground-muted shadow-lg backdrop-blur-md", "transition-colors hover:text-foreground");
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FaSearch className="size-3" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0) {
    t3 = <button onClick={t0} className={t1} aria-label="Open search">{t2}</button>;
    $[4] = t0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}